import React from 'react'
import Button from '@atlaskit/button/new'

/**
 * Error Boundary that catches React render crashes.
 * Without this, any component crash results in a blank white screen.
 * CloudWatch RUM auto-captures the error via window.onerror,
 * but this provides a user-friendly fallback UI with a retry option.
 */
class RumErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('RumErrorBoundary caught error:', error, errorInfo)
  }

  handleRetry = () => {
    this.setState({ hasError: false })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '40px',
          maxWidth: '500px',
          margin: '60px auto',
          textAlign: 'center',
          color: 'var(--ds-text, #172B4D)'
        }}>
          <h3 style={{ marginBottom: '8px' }}>Something went wrong</h3>
          <p style={{
            color: 'var(--ds-text-subtlest, #626F86)',
            marginBottom: '16px'
          }}>
            An unexpected error occurred. Please try again.
          </p>
          <Button appearance="primary" onClick={this.handleRetry}>
            Try Again
          </Button>
        </div>
      )
    }
    return this.props.children
  }
}

export default RumErrorBoundary
